import * as testConst from 'app/constants/tests';

interface QuestionTableProps {
  groupType: number;
  groupOptions: string;
}

const QuestionTable = (props: QuestionTableProps) => {
  const { groupType, groupOptions } = props;
  if (groupType !== testConst.QUESTION_OPTION || !groupOptions?.includes('##')) {
    return null;
  }

  return (
    <table className="table table-striped table-bordered mb-5 col-md-11 mx-auto">
      <tbody>
        {(groupOptions?.split('//') || []).map((label: string) => {
          const [key, value] = label.split('##');
          return (
            <tr key={label}>
              <th scope="row">{key}</th>
              <th scope="row">{value}</th>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default QuestionTable;
